// Shared dashboard date-range presets, so every page (Executive, Sales
// Performance, per-member) computes identical ranges — the same button always
// means the same dates, and therefore the same numbers.

// A date N days ago in KSA time, as YYYY-MM-DD (en-CA gives that format).
export function ksaDate(daysAgo = 0) {
  const d = new Date();
  d.setDate(d.getDate() - daysAgo);
  return d.toLocaleDateString('en-CA', { timeZone: 'Asia/Riyadh' });
}

// The unified preset list used across all dashboards.
export const PRESET_KEYS = ['today', 'yesterday', '7d', '30d', '90d', 'lifetime', 'custom'];

// Translation keys for each preset label (reuse the exec* keys — already EN+AR).
export const PRESET_LABEL_KEY = {
  today: 'execToday', yesterday: 'execYesterday', '7d': 'execLast7',
  '30d': 'execLast30', '90d': 'execLastQuarter', lifetime: 'execAllTime', custom: 'execCustom',
};

// Resolve a preset (+ optional custom endpoints) to { from, to } as YYYY-MM-DD.
// 'lifetime' spans a wide range so it captures all data; 'custom' returns {}
// until both endpoints are chosen (callers skip the fetch on empty).
export function presetRange(preset, customFrom, customTo) {
  switch (preset) {
    case 'today': return { from: ksaDate(0), to: ksaDate(0) };
    case 'yesterday': return { from: ksaDate(1), to: ksaDate(1) };
    case '7d': return { from: ksaDate(6), to: ksaDate(0) };
    case '30d': return { from: ksaDate(29), to: ksaDate(0) };
    case '90d': return { from: ksaDate(89), to: ksaDate(0) };
    case 'lifetime': return { from: '2000-01-01', to: ksaDate(0) };
    case 'custom': return (customFrom && customTo) ? { from: customFrom, to: customTo } : {};
    default: return { from: ksaDate(0), to: ksaDate(0) };
  }
}
